import 'lazysizes/plugins/bgset/ls.bgset.min'
import 'lazysizes'
import Alpine from 'alpinejs'
window.Alpine = Alpine
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

// Helpers
import './helpers/convertObjectNumbersToString'
import './helpers/pushDataLayer'

// Stores
import './stores/mobile-menu'
import './stores/backdrop'
import './stores/service-menu'
import './stores/gallery'
import './stores/header'
import './stores/lease-stickybar'
import './stores/office-membership'
import './stores/language-switch'

// Components
import './components/swiper'
import './components/isStickyHeader'
import './components/isStickyLeaseTopbar'
import './components/leaseMap'
import './components/leaseSearch'
import './components/leaseSearchMap'
import './components/lottie'
import './components/noticesHandler'
import './components/scrollToElement'
import './components/citySlug'
import './components/sitemap'

// Forms
import './components/searchAgent'
import './components/bookingForm'
import './components/bookingFormOffice'
import './components/contactForm'
import './components/parkingConditionsForm'

// Other
import 'focus-visible'
import 'iframe-resizer/js/iframeResizer'

declare global {
  interface Window {
    Alpine: any
    isStickyHeader: any
    isStickyLeaseTopbar: any
    oldScroll: any
    initLeaseMap: any
    initLeaseSearchMap: any
    google: any
    Swiper: any
    leaseMap: any
    leaseSearchMap: any
    updateMarkers: any
    removeMarkers: any
    markers: any
    setMarkers: any
    addLeaseSearchMarkers: any
    iFrameResize: any
    scrollToElement: any
    grecaptcha: any
    dataLayer: any[]
    Lottie: any
    pushDataLayer: any
  }
}

export enum Endpoints {
  cities = '/cities',
  searchAgent = '/forms/search-agent',
  bookingForm = '/forms/book-appointment',
  contactForm = '/forms/contact',
  parkingConditionsForm = '/forms/parking-approve-terms',
  leasesSearch = '/leases/search',
}

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.start()
